"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 11: Color Dreams
 * ------------------------------------------------------------------ */
// Color Dreams

function register(Mappers) {
  Mappers[11] = function (nes) {
    this.nes = nes;
  };

  Mappers[11].prototype = new Mappers[0]();

  Mappers[11].prototype.write = function (address, value) {
    if (address < 0x8000) {
      Mappers[0].prototype.write.apply(this, arguments);
      return;
    }

    var romCount = this.nes.rom.romCount;

    // Bits 0-2 select a 16 KB PRG pair, bits 4-5 an 8 KB CHR bank.
    var prgBank = ((value & 0x07) * 2) % romCount;
    this.loadRomBank(prgBank, 0x8000);
    this.loadRomBank((prgBank + 1) % romCount, 0xc000);

    if (this.nes.rom.vromCount > 0) {
      var chrBank = ((value >> 4) & 0x03) * 2;
      this.load8kVromBank(chrBank, 0x0000);
    }
  };

  Mappers[11].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("Color Dreams: Invalid ROM! Unable to load.");
    }

    this.reset();
    this.loadCHRROM();
    this.loadBatteryRam();
    this.loadTrainer();
    // The board powers on with the last bank pair at $C000.
    this.loadRomBank(this.nes.rom.romCount - 2, 0x8000);
    this.loadRomBank(this.nes.rom.romCount - 1, 0xc000);
    this.resetIrqHandler();
  };
}

module.exports = { register: register };
